module.exports = __webpack_public_path__ + "static/img/4.dd338be.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/2/7/3/eng/4.png
// module id = 3JxR
// module chunks = 0